import { useState, useEffect } from "react";
import api from "@/lib/api";

// Fetch a resource list and map to {value,label} options.
export function useOptions(endpoint, labelKey = "name", valueKey = "id") {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(endpoint, { params: { page_size: 200 } });
        const items = Array.isArray(data) ? data : data.items || [];
        setOptions(items.map((i) => ({ value: i[valueKey], label: i[labelKey], raw: i })));
      } catch { setOptions([]); }
    })();
  }, [endpoint]); // eslint-disable-line
  return options;
}
